const config = {
  siteTitle: 'The Secret Blog',
  siteTitleAlt: 'Secret Blog',
  pathPrefix:'',
  author: 'Rahul',
  siteLogo: '/logo.png',
  siteUrl: 'https://blog.rahul3v.xyz',
  repo: 'https://github.com/rahul3v',
  linkedin:'https://linkedin.com/company/rahul3v',
  dateFromFormat: 'YYYY-MM-DD',
  dateFormat: ' Do MMM, YYYY',
  siteDescription:'By a Full Stack developer and designer writing open source mini-projects and much more..',
  googleAnalyticsID: 'UA-139154164-2',
  userName: 'rahul3v',
  userEmail: 'hello@rahul3v.xyz',
  themeColor: '#155CE6',
  backgroundColor: '#ffffff',
}

module.exports = config